let clickedCarouselIndex = 0;

export function setCarouselIndex(val) {
    clickedCarouselIndex = val;
}

export function getCarouselIndex() {
    return clickedCarouselIndex;
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/config.ts